<div class="button-wrapper-grid">
  <ng-container *ngFor="let landType of landTypesArray; index as i">
    <label class="cnt-button" [ngClass]="{ active: selectedHash?.[landType.key] }">
      <input type="checkbox" [value]="landType.key" (change)="toggle(landType.key)" />
      <div class="cnt-button-icon">
        <curbnturf-site-svgs [type]="landType.key" [white]="selectedHash?.[landType.key]"> </curbnturf-site-svgs>
      </div>
      <div class="cnt-button-copy">{{ landType.value }}</div>
    </label>
  </ng-container>
</div>
